export const BaseSettingsDialogTestIds = {
  dialogBackdrop: 'dialog_backdrop',
  dialogContainer: 'dialog_container',
  dialogHeader: 'dialog_header',
  buttonBack: 'button_back',
  iconBack: 'icon_back',
  dialogContent: 'dialog_content',
  listChatSettings: 'list_chat_settings',
  dialogMainContent: 'dialog_main_content',
  dialogTitle: 'dialog_title',
  dividerTitle: 'divider_title',
  listItemProfil: 'list_item_profil',
  listItemPrivacy: 'list_item_privacy',
  listItemNotification: 'list_item_notification',
  listItemSchluesselverwaltung: 'list_item_schluesselverwaltung',
  listItemSessions: 'list_item_sessions',
  listItemActions: 'list_item_actions',
  listItemDevices: 'list_item_devices',
  listItemGeneral: 'list_item_general',
  listItemSecurity: 'list_item_security',
  listItemMedia: 'list_item_media',
  listItemProduct: 'list_item_product',
  listItemDataprivacy: 'list_item_dataprivacy'
} as const;
